import { useEffect, useState } from "react";

/**
 * Floating gold sparkle decorations rendered as fixed background ornaments.
 * They drift slowly, giving the page a subtle "luxury" shimmer.
 */
export default function FloatingSparkles({ count = 12 }) {
    const [dots, setDots] = useState([]);
    useEffect(() => {
        const arr = Array.from({ length: count }, (_, i) => ({
            id: i,
            left: Math.random() * 100,
            top: Math.random() * 100,
            size: 4 + Math.random() * 8,
            delay: Math.random() * 4,
            duration: 4 + Math.random() * 4,
            opacity: 0.25 + Math.random() * 0.35,
        }));
        setDots(arr);
    }, [count]);

    return (
        <div className="absolute inset-0 pointer-events-none overflow-hidden" aria-hidden>
            {dots.map((d) => (
                <span
                    key={d.id}
                    className="absolute rounded-full animate-sparkle-pulse"
                    style={{
                        left: `${d.left}%`,
                        top: `${d.top}%`,
                        width: `${d.size}px`,
                        height: `${d.size}px`,
                        background: "radial-gradient(circle, rgba(229,200,124,0.9) 0%, rgba(212,175,55,0.4) 50%, transparent 70%)",
                        animationDelay: `${d.delay}s`,
                        animationDuration: `${d.duration}s`,
                        opacity: d.opacity,
                    }}
                />
            ))}
        </div>
    );
}
